import { Environment } from "./environment.model";

export const environment: Environment = {
  production: true,
  name: 'prod',
  rh_env: 'production',
  version: '#APP_VERSION#',
  API_URL: 'https://us-east-1.hub-cms-api.atpco.net',
  FLIGHT_SEARCH_UPA_URL: 'https://us-east-1.hub-cms-api.atpco.net/api/upas',
  FLIGHT_SEARCH_CURL_URL: 'https://retailing.apis.atpco.net/routehappy/consolidated',
  msalConfig: { 
    auth: { 
      clientId: 'b19e8c15-3e04-465a-aab7-4ef4d463c0d8',
    }
  },
  apiConfig: {
    scopes: [
      'https://login.atpco.net/hub-delivery-api/scp.hub-delivery-api',
    ],
    graphScopes: ['user.read'],
    graphUri: 'https://graph.microsoft.com/v1.0/me',
    apiUri: '',
    apiKey: '',
  },
  b2cPolicies: {
    names: { signUpSignIn: 'b2c_1a_oidc_auth_code_flow' },
    authorities: {
      signUpSignIn: {
        authority:
          'https://login.atpco.net/login.atpco.net/B2C_1A_OIDC_AUTH_CODE_FLOW',
      },
    },
    authorityDomain: 'login.atpco.net',
    
  },
  redirectUri: 'https://hub.atpco.net',
  postLogoutRedirectUri: 'https://hub.atpco.net',
  silentRedirectUri: 'https://hub.atpco.net/auth-silent.html',
  faroCollectorUrl: 'https://faro-collector-prod-us-east-3.grafana.net/collect/a7bc26e63c304d51f6d8e641468365b2',
  faroAppName: 'Routehappy Hub UI',
  umsInviteDetails: {
    clientId: "b19e8c15-3e04-465a-aab7-4ef4d463c0d8",
    redirectUri: "https://hub.atpco.net",
    applicationName: "Routehappy Hub",
    applicationLink: "https://hub.atpco.net",
    templateId: 3
  },
  USERFLOW_TOKEN: 'ct_us1_dhtl52gtsbemrcg3q5a3up7vpu',
};